import React from "react";

type PageSectionDividerProps = {
  className?: string;
};

const PageSectionDivider: React.FC<PageSectionDividerProps> = ({
  className = "",
}) => {
  return <div className={`my-[24px] h-px w-full bg-border-default ${className}`.trim()} />;
};

export default PageSectionDivider;
